module.exports = __webpack_public_path__ + "img/make-a-joyful-noise.0cbdaa70.svg";